import { AppPermission } from '@/app.permission';
import { PBAC } from 'pbac-validator';

/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(initialState: { user?: API.User | undefined }) {
  const { user } = initialState || {};
  const pbac = new PBAC(user?.pbacStatements);

  const accessObj: any = {};
  Object.keys(AppPermission).forEach((k) => {
    const permission: string = (AppPermission as any)[k];

    accessObj[permission] = pbac.evaluate({
      resource: permission.split('.')[0],
      action: permission.split('.')[1],
    });
  });

  return accessObj;
}
